import { __assign } from "tslib";
import React from "react";
import moments from "moment";
import { TextField } from "@material-ui/core";
import { DatePicker as WebDatePicker, LocalizationProvider } from "@material-ui/pickers";
import MomentAdapter from "@material-ui/pickers/adapter/moment";
function DatePicker(_a) {
  var disabled = _a.disabled,
    expectedPayOffDate = _a.expectedPayOffDate,
    setExpectedPayOffDate = _a.setExpectedPayOffDate,
    setOpen = _a.setOpen,
    setDisabledSubmit = _a.setDisabledSubmit,
    disabledSecond = _a.disabledSecond,
    currentDate = _a.currentDate,
    open = _a.open;
  var onKeyDown = function (e) {
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: MomentAdapter
  }, /*#__PURE__*/React.createElement(WebDatePicker, {
    onOpen: function () {
      return setOpen(true);
    },
    onClose: function () {
      return setOpen(false);
    },
    open: open,
    autoOk: false,
    onError: function (error) {
      if (error != null) {
        setDisabledSubmit(true);
      }
    },
    renderInput: function (props) {
      return /*#__PURE__*/React.createElement(TextField, __assign({
        onKeyDown: onKeyDown
      }, props));
    },
    disablePast: true,
    maxDate: moments().add(2, "month"),
    minDate: moments().subtract(1, "day"),
    shouldDisableDate: function (day) {
      if (disabledSecond) {
        return !(moments().clone().endOf("month").format("MM/DD/YYYY") === day.format("MM/DD/YYYY") || moments().add(1, "month").clone().endOf("month").format("MM/DD/YYYY") === day.format("MM/DD/YYYY"));
      }
      if (moments().add(30, "day") <= day) {
        return true;
      }
      var d = new Date();
      if (day.format("YYYY") < d.getFullYear()) {
        setDisabledSubmit(true);
      } else {
        setDisabledSubmit(false);
      }
      return false;
    },
    disabled: disabled,
    value: expectedPayOffDate || currentDate,
    onChange: function (date) {
      setExpectedPayOffDate(moments(date).format("MM/DD/YYYY"));
    },
    animateYearScrolling: true
  }));
}
export default DatePicker;